<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="NoContractSnsSearch"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      @customerRowDblClick="customerRowDblClick"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleLeft>
        <div>SN信息列表</div>
      </template>

      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        ></text-field>

        <text-field
          v-model:value="conditionData.BrandId"
          labelText="品牌名称:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguBrand"
          class="condition-container-input"
        ></text-field>

        <text-field
          v-model:value="conditionData.ProductId"
          labelText="产品类别:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguNameProduct"
          class="condition-container-input"
        ></text-field>

        <text-field
          v-model:value="conditionData.ModelNoId"
          labelText="产品型号:"
          type="select"
          :selectRemoteSearchData="selectOuguNameModelSelect"
          class="condition-container-input"
        ></text-field>

        <text-field
          v-model:value="conditionData.sn"
          labelText="SN号:"
          class="condition-container-input"
        ></text-field>
      </template>

      <template v-slot:oprator="$opData">
        <!-- <div class="opration">
          <del-button
            class="item"
            :useConfirm="true"
            comfirmMessage="确定删除吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="delSingleUser($opData.data)"
          ></del-button>
        </div> -->
        <del-border
						:useConfirm="true" comfirmMessage="确定删除吗？" 
						comfirmOkText="确定" comfirmCancelText="取消" 
						@buttonClick="delSingleUser($opData.data)"></del-border>
      </template>
    </tabel-panel>
    <pop-dialog
      id="saveBOX"
      @confirmClick="listDataSave"
      v-if="saveBOX"
      ref="getMenuList"
      :meta="popDialogList"
      detailShowType="data"
      textButtons="保存"
      @dialogClose="saveBOX = false"
    >
      <template v-slot>
        <div class="saveBox">
          <el-form
            :model="RepairDetectEdit"
            :rules="rules"
            ref="saveEdit"
            label-width="85px"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="品牌名称:" prop>
                    <el-select
                      v-model="saveEdit.Brand_Id"
                      clearable
                      placeholder="请选择"
                      @change="addProductSelect"
                      required
                      size="small"
                    >
                      <el-option
                        v-for="item in BrandData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品类型:" prop>
                    <el-select
                      v-model="saveEdit.ProCate_Id"
                      clearable
                      size="small"
                      placeholder="请选择"
                      @change="addModelSelect"
                    >
                      <el-option
                        v-for="item in ProductData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品型号:" prop="mid">
                    <el-select
                      v-model="saveEdit.ModelNo_Id"
                      clearable
                      size="small"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in modelData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="系统:" prop>
                    <el-input
                      v-model="saveEdit.SystemName"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="Fusion版本:" prop>
                    <el-input
                      v-model="saveEdit.Fusion"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="SN号:" prop>
                    <el-input
                      v-model="saveEdit.Name"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="MAC地址:" prop="BrandName">
                    <el-input
                      v-model="saveEdit.MACAddr"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="IP地址:" prop="ProCateName">
                    <el-input
                      v-model="saveEdit.IPAddr"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="网关掩码DNS:" prop="ModelNoName">
                    <el-input
                      v-model="saveEdit.DNSAddr"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="LicenseName:"
                    label-width="89px"
                    prop="SerialNoName"
                  >
                    <el-input
                      v-model="saveEdit.Licensee"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="Wavelink注册信息:"
                    label-width="124px"
                    prop=""
                  >
                    <el-input
                      v-model="saveEdit.RegeditInfo"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <div class="grid-content bg-purple">
                  <el-form-item label="合同号:" prop="AttachName">
                    <el-input
                      v-model="saveEdit.ContractName"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </template>
    </pop-dialog>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import delBorder from "@/components/delBorder.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import { ServerSNEdit, ServerSNDelById } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";

export default {
  name: "serviceSN",
  components: {
    textField,
    delBorder,
    tabelPanel,
    popDialog,
  },
  data() {
    return {
      inputValue: "明细",
      activeName: "second",
      loadShow: false,
      saveBOX: false,
      BrandData: null,
      ProductData: null,
      modelData: null,
      rowTemplate: [
        {
          headerLabel: "客户",
          width: 120,
          dataIndex: "CompName",
        },
        {
          headerLabel: "品牌",
          dataIndex: "BrandName",
        },
        {
          headerLabel: "类型",
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN号",
          dataIndex: "SerialNoName",
        },
        {
          headerLabel: "合同号",
          dataIndex: "ContractName",
        },
        {
          headerLabel: "合同客户",
          dataIndex: "ConCompName",
        },
        {
          headerLabel: "操作",
          slot: "oprator",
        },
      ],
      conditionData: {
        compid: null,
        BrandId: null,
        ProductId: null,
        ModelNoId: null,
        sn: null,
      },
      saveEdit: null,
      selectData: [
        {
          label: "有实物快递",
          value: 63,
        },
        {
          label: "无实物快递",
          value: 64,
        },
      ],
      ModelIllData: null,
      RepairDetectEdit: {
        id: 0, //Int	维修信息id	是
        result: "", //String	实际检测结果	是
        actills: "", //String	实际症状类型	是
        noexp: "", //String	递送方式	是
      },
      rules: {
        noexp: [
          {
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        actills: [
          {
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.companyAdd();
  },
  methods: {
    async selectOuguName() {
      let source = await tableApi.CompanyInfo();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguNameProduct() {
      let source = await tableApi.ProductSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguNameModelSelect() {
      let source = await tableApi.modelSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    companyAdd() {
      // 品牌
      tableApi.BrandSelect().then((data) => {
        if (data.code == 0) {
          this.BrandData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 类型
    addProductSelect() {
      let Bid = this.saveEdit.ContractNam;
      tableApi.ProductSelect({ Bid }).then((data) => {
        if (data.code == 0) { 
          this.ProductData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 型号
    addModelSelect() {
      let ProductCategoryId = this.saveEdit.ContractNam;
      tableApi.modelSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.modelData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    delSingleUser({ row }) {
      let { Id } = row;
      ServerSNDelById({ Id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    handlePop(row) {
      this.saveEdit = row;
      // this.addModelIllSelect(row.ProCate_Id)
      // this.saveBOX = true
      console.log("this.saveEdit", this.saveEdit);
      // this.$nextTick(() => {
      //     this.$refs.getMenuList.showPopDialog(
      //         {row},
      //         "维修检测编辑信息",
      //         "slot"
      //     )
      // })
    },
    // 产品症状类型
    addModelIllSelect(ProductCategoryId) {
      tableApi.ModelIllSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.ModelIllData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 保存api
    listDataSave({ slotData }) {
      this.$refs["saveEdit"].validate((valid) => {
        if (valid) {
			this.RepairDetectEdit.id = slotData.row.Id;
			console.log('保存api', this.saveEdit)
			let parms = JSON.stringify(this.saveEdit);
			ServerSNEdit({data: parms}).then((data) => {
				if (data.code == 0) {
					this.saveBOX = false;
					successMsg(data.message);
					this.reloadData();
				} else {
					errMsg(data.message);
				}
			});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
		console.log("2", slotData);
    },
    customerRowDblClick(row) {
      console.log("23", row);
      this.saveEdit = row;
      this.saveBOX = true;
      this.$nextTick(() => {
        this.$refs.getMenuList.showPopDialog({ row }, "SN编辑信息", "slot");
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }
    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }

  ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    overflow: auto !important;
  }
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
  }

  .el-row {
    margin-bottom: 16px;
  }
  .saveBox {
    padding-bottom: 20px;
  }
  ::v-deep .del-button-icon {
    margin-right: 0;
  }
}
</style>
